/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style13 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style14 = require('antd/lib/select/style');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _style15 = require('antd/lib/col/style');

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _style16 = require('antd/lib/row/style');

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _style17 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style18 = require('antd/lib/date-picker/style');

var _datePicker = require('antd/lib/date-picker');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _style19 = require('antd/lib/alert/style');

var _alert = require('antd/lib/alert');

var _alert2 = _interopRequireDefault(_alert);

var _style20 = require('antd/lib/modal/style');

var _modal = require('antd/lib/modal');

var _modal2 = _interopRequireDefault(_modal);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _style21 = require('antd/lib/message/style');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style22 = require('antd/lib/table/style');

var _table = require('antd/lib/table');

var _table2 = _interopRequireDefault(_table);

var _style23 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _style24 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _template = require('../../../common/template');

var _template2 = _interopRequireDefault(_template);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _immutable = require('immutable');

var _actions = require('reduxPath/actions');

var Actions = _interopRequireWildcard(_actions);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('util/config');

var _tool = require('../../../utils/tool');

var _search = require('./search');

var _search2 = _interopRequireDefault(_search);

require('./index.less');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;
var TextArea = _input2.default.TextArea;
var Column = _table2.default.Column,
    ColumnGroup = _table2.default.ColumnGroup;

var _ref = (0, _jsx3.default)('div', {
  className: 'table-package-img'
});

var _ref2 = (0, _jsx3.default)('span', {
  className: 'ant-divider'
});

var _ref3 = (0, _jsx3.default)('span', {
  className: 'ant-divider'
});

var _ref4 = (0, _jsx3.default)('span', {
  className: 'ant-divider'
});

var _ref5 = (0, _jsx3.default)(_icon2.default, {
  type: 'plus'
});

var _ref6 = (0, _jsx3.default)('span', {}, void 0, '\u90E8\u4EF6\u7C7B\u578B\uFF1A');

var _ref7 = (0, _jsx3.default)(Option, {
  value: 0
}, void 0, 'VCU');

var _ref8 = (0, _jsx3.default)(Option, {
  value: 1
}, void 0, 'BMS');

var _ref9 = (0, _jsx3.default)(Option, {
  value: 2
}, void 0, 'MCCU');

var _ref10 = (0, _jsx3.default)(Option, {
  value: 3
}, void 0, 'ICM');

var _ref11 = (0, _jsx3.default)(Option, {
  value: 4
}, void 0, 'CP');

var _ref12 = (0, _jsx3.default)(Option, {
  value: 5
}, void 0, 'MP');

var _ref13 = (0, _jsx3.default)(Option, {
  value: 6
}, void 0, 'BOXBMS');

var _ref14 = (0, _jsx3.default)(Option, {
  value: 7
}, void 0, '\u5176\u4ED6');

var _ref15 = (0, _jsx3.default)('span', {}, void 0, '\u7248\u672C\uFF1A');

var Main = function (_Component) {
  (0, _inherits3.default)(Main, _Component);

  function Main(props, context) {
    (0, _classCallCheck3.default)(this, Main);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Main.__proto__ || (0, _getPrototypeOf2.default)(Main)).call(this, props, context));

    _this.getPagedVersionList = function () {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var paramsQuest = {
        page: page,
        rows: 10,
        productId: _this.props.uid,
        keyword: _this.state.keywords,
        status: _this.state.status
      };
      (0, _tool.http)(_config.apiJson.getPagedVersionList, paramsQuest).then(function (res) {
        _this.setState({
          versionList: res,
          page: page
        });
      });
    };

    _this.onChange = function (pagination) {
      _this.getPagedVersionList(pagination.current);
    };

    _this.search = function (o) {
      _this.setState({
        keywords: o.keyWord,
        status: o.status,
        page: 1
      }, function () {
        _this.getPagedVersionList();
      });
    };

    _this.deleteVersion = function (id) {
      (0, _tool.http)(_config.apiJson.deleteVersion, { id: id }).then(function (res) {
        if (res == true) {
          _message2.default.success("删除升级包成功！");
          setTimeout(function () {
            _this.getPagedVersionList();
          }, 500);
        }
      });
    };

    _this.handleSubmit = function (e) {
      e.preventDefault();
    };

    _this.showStatusModal = function (e) {
      console.log('我是当前选中id', e);
      _this.setState({
        statusvisible: true,
        id: e
      });
    };

    _this.handleOk = function (e) {
      console.log(e, '我是处理数据');
      _this.updateVerdionStaus();
    };

    _this.handleCancel = function (e) {
      console.log(e);
      _this.setState({
        statusvisible: false

      });
    };

    _this.getBaseVersionDetailById = function (val, i) {
      _this.setState({
        codeVal: '',
        infoVal: '',
        explainVal: '',
        timeVal: '',
        ruleVal: []
      });
      (0, _tool.http)(_config.apiJson.getBaseVersionDetailById, { versionId: val }).then(function (res) {
        if (res) {
          if (i) {
            var ex = res.remark.replace(/\n/g, '<br/>');
            _this.setState({
              codeVal: res.outVersion,
              infoVal: res.outVersionNote,
              explainVal: { __html: ex },
              timeVal: res.sendTime,
              ruleData: JSON.parse(res.influencedPartVersion).join('；')
            });
          } else {
            if (res.influencedPartVersion) {
              var data = JSON.parse(res.influencedPartVersion);
              var dataTwo = data.map(function (item) {
                return item.split(' ');
              });
              var a = ['VCU', 'BMS', 'MCCU', 'ICM', 'CP', 'MP', 'BOXBMS', '其他'];
              var allData = dataTwo.map(function (item) {
                return a.indexOf(item[0]) < 0 ? {
                  componentType: a.indexOf('其他'),
                  operator: item[0],
                  partFirmwareVersion: item[1]
                } : {
                  componentType: a.indexOf(item[0]),
                  operator: '',
                  partFirmwareVersion: item[1]
                };
              });
              _this.setState({
                codeVal: res.outVersion,
                infoVal: res.outVersionNote,
                explainVal: res.remark,
                timeVal: res.sendTime,
                ruleVal: allData
              });
            } else {
              _this.setState({
                codeVal: res.outVersion,
                infoVal: res.outVersionNote,
                explainVal: res.remark,
                timeVal: res.sendTime,
                ruleVal: []
              });
            }
          }
        }
      });
    };

    _this.handleCancelDetail = function () {
      _this.setState({
        visibleShow: false
      });
    };

    _this.handleCancelEdit = function () {
      _this.setState({
        editShow: false
      });
    };

    _this.handleChangeType = function (i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(_this.state.ruleVal));
      a[i].componentType = val;
      _this.state.ruleVal.splice(i, 1);
      _this.setState(function (prevState) {
        delete prevState.ruleVal;
        return prevState;
      });
      _this.setState({
        ruleVal: a
      });
    };

    _this.handleClose = function () {
      _this.setState({
        visible: false
      });
    };

    _this.getCode = function (e) {
      var value = e.target.value;

      _this.setState({
        codeVal: value
      });
    };

    _this.getInfo = function (e) {
      var value = e.target.value;

      _this.setState({
        infoVal: value
      });
    };

    _this.getExplain = function (e) {
      var value = e.target.value;

      _this.setState({
        explainVal: value
      });
    };

    _this.getTime = function (e) {
      _this.setState({
        timeVal: e
      });
    };

    _this.skipSubmit = function () {
      var _this$state = _this.state,
          codeVal = _this$state.codeVal,
          infoVal = _this$state.infoVal,
          timeVal = _this$state.timeVal,
          explainVal = _this$state.explainVal,
          ruleVal = _this$state.ruleVal,
          versionId = _this$state.versionId,
          page = _this$state.page;

      if (!codeVal) {
        _message2.default.warning('请输入外部版本号');
        return false;
      }
      if (!infoVal) {
        _message2.default.warning('请输入外部版本简介');
        return false;
      }
      if (!explainVal) {
        _message2.default.warning('请输入外部版本更新说明');
        return false;
      }
      if (!timeVal) {
        _message2.default.warning('请选择正式发布时间');
        return false;
      }
      if (ruleVal.length <= 0) {
        _message2.default.warning('请至少输入一个版本详情');
        return false;
      }
      var tem = {
        '0': 'VCU',
        '1': 'BMS',
        '2': 'MCCU',
        '3': 'ICM',
        '4': 'CP',
        '5': 'MP',
        '6': 'BOXBMS',
        '7': '其他'
      };
      var data = ruleVal.map(function (item) {
        if (item.componentType == 7) {
          return (item.operator ? item.operator : '') + ' ' + (item.partFirmwareVersion ? item.partFirmwareVersion : '');
        } else {
          return (tem[item.componentType] ? tem[item.componentType] : '') + ' ' + (item.partFirmwareVersion ? item.partFirmwareVersion : '');
        }
      });
      var params = {
        versionId: versionId,
        outVersion: codeVal,
        outVersionNote: infoVal,
        influencedPartVersion: (0, _stringify2.default)(data),
        remark: explainVal,
        sendTime: timeVal
      };
      (0, _tool.http)(_config.apiJson.updateBaseVersionDetail, params).then(function (res) {
        if (res) {
          _message2.default.success('更新成功！');
          _this.handleCancelEdit();
          _this.getPagedVersionList(page);
          _this.setState({
            codeVal: '',
            infoVal: '',
            explainVal: '',
            timeVal: '',
            ruleVal: []
          });
        }
      });
    };

    _this.state = {
      versionList: [],
      vList: [{ key: '1', value: '研发版本' }, { key: '2', value: '测试版本' }, { key: '3', value: '发布版本' }],
      id: '',
      currentVersion: '',
      statusvisible: false,
      name: '',
      keywords: '',
      total: 0,
      page: 1,
      status: null,
      visibleShow: false,
      editShow: false,
      ruleVal: [],
      visible: true,
      codeVal: '',
      infoVal: '',
      explainVal: '',
      timeVal: '',
      versionId: '',
      ruleData: ''
    };
    return _this;
  }

  (0, _createClass3.default)(Main, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _immutable.is)((0, _immutable.fromJS)(this.props), (0, _immutable.fromJS)(nextProps)) || !(0, _immutable.is)((0, _immutable.fromJS)(this.state), (0, _immutable.fromJS)(nextState));
    }

    //分页获取版本列表

    //换页

    //  弹框组件

  }, {
    key: 'handleStatusChange',
    value: function handleStatusChange(value) {
      console.log('修改状态', value);
      this.setState({
        currentVersion: value
      });
    }
    //  修改状态接口

  }, {
    key: 'updateVerdionStaus',
    value: function updateVerdionStaus() {
      var _this2 = this;

      var _state = this.state,
          id = _state.id,
          currentVersion = _state.currentVersion;

      return (0, _tool.http)(_config.apiJson.updateVerdionStaus, { id: id, stauts: currentVersion }).then(function (res) {
        _this2.setState({
          statusvisible: false
        });
        _this2.getPagedVersionList();
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      (0, _tool.http)(_config.apiJson.getProduct, { productId: this.props.uid }).then(function (res) {
        var name = res.name;
        _this3.setState({
          name: name
        });
      });
      (0, _tool.http)(_config.apiJson.getPagedVersionList, { productId: this.props.uid, rows: 10 }).then(function (res) {
        var versionList = res;
        var total = res.total;
        _this3.setState({
          versionList: versionList,
          total: total
        });
      });
    }
  }, {
    key: 'showDetails',
    value: function showDetails(val) {
      this.setState({
        visibleShow: true
      });
      this.getBaseVersionDetailById(val, 1);
    }
  }, {
    key: 'showEdit',
    value: function showEdit(val) {
      this.setState({
        editShow: true,
        versionId: val
      });
      this.getBaseVersionDetailById(val);
    }
  }, {
    key: 'clickChange',
    value: function clickChange() {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a.push({
        componentType: 0,
        operator: '',
        partFirmwareVersion: null
      });
      if (a.length > 4) return;
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: 'handleChangeStatus',
    value: function handleChangeStatus(i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a[i].operator = val.target.value;
      this.state.ruleVal.splice(i, 1);
      this.setState(function (prevState) {
        delete prevState.ruleVal;
        return prevState;
      });
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: 'handleChangeVal',
    value: function handleChangeVal(i, val) {
      var a = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      a[i].partFirmwareVersion = val.target.value;
      this.state.ruleVal.splice(i, 1);
      this.setState(function (prevState) {
        delete prevState.ruleVal;
        return prevState;
      });
      this.setState({
        ruleVal: a
      });
    }
  }, {
    key: 'sc',
    value: function sc(i) {
      var copy = [].concat((0, _toConsumableArray3.default)(this.state.ruleVal));
      copy.splice(i, 1);
      this.setState({
        ruleVal: copy
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state2 = this.state,
          versionList = _state2.versionList,
          name = _state2.name,
          total = _state2.total,
          page = _state2.page,
          vList = _state2.vList,
          visible = _state2.visible,
          codeVal = _state2.codeVal,
          infoVal = _state2.infoVal,
          explainVal = _state2.explainVal,
          timeVal = _state2.timeVal,
          ruleVal = _state2.ruleVal,
          ruleData = _state2.ruleData;
      var _props = this.props,
          increate = _props.increate,
          uid = _props.uid;

      var formItemLayout = {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 }
      };
      var list = versionList ? versionList : {};

      var pagination = {
        defaultCurrent: 1,
        current: page,
        total: list.total,
        pageSize: 10,
        showTotal: function showTotal(total) {
          return '\u5171\u8BA1 ' + total + ' \u6761';
        },
        showQuickJumper: true
      };
      var columns = [{
        title: '升级包',
        dataIndex: 'packageName',
        key: 'packageName',
        className: 'aaa',
        render: function render(text) {
          return (0, _jsx3.default)('div', {
            className: 'table-package'
          }, void 0, _ref, (0, _jsx3.default)('div', {
            className: 'table-package-name'
          }, void 0, text));
        }
      }, {
        title: '内部版本号',
        dataIndex: 'versionCode',
        key: 'versionCode'
      }, {
        title: '外部版本号',
        dataIndex: 'outVersion',
        key: 'outVersion'
      },
      // {
      //     title: '设备校验值',
      //     dataIndex: 'packageVerifyValue',
      //     key: 'packageVerifyValue',
      // },
      {
        title: '版本要点',
        dataIndex: 'remark',
        key: 'remark'
      }, {
        title: '版本状态',
        key: 'vs',
        render: function render(text) {
          // console.log(vList.filter(item => text.status== item.key),'我是啥')
          // console.log(text, '按就想看看')
          return text.status !== null ? vList.filter(function (item) {
            return text.status == item.key;
          })[0].value : '';
        }
      }, {
        title: '新增时间',
        dataIndex: 'createTime',
        key: 'createTime'
      }, {
        title: '操作者',
        dataIndex: 'creator',
        key: 'creator'
      }, {
        title: '操作',
        key: 'action',
        render: function render(text, order) {
          return (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            onClick: _this4.showDetails.bind(_this4, order.id)
          }, void 0, '\u8BE6\u60C5'), _ref2, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            onClick: _this4.showEdit.bind(_this4, order.id)
          }, void 0, '\u7F16\u8F91'), _ref3, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            onClick: _this4.showStatusModal.bind(_this4, order.id)
          }, void 0, '\u72B6\u6001\u53D8\u66F4'), _ref4, (0, _jsx3.default)('a', {
            href: 'javascript:void(0);',
            onClick: _this4.deleteVersion.bind(_this4, order.id)
          }, void 0, '\u5220\u9664'));
        }
      }];

      var data = [];
      var rows = list.rows ? list.rows : [];
      rows.map(function (item, index) {
        var option = {
          "key": index,
          "id": item.id,
          "packageName": item.fileOriginName || item.packageName,
          "versionCode": item.versionCode,
          "versionName": item.versionName,
          "outVersion": item.outVersion,
          "packageVerifyValue": item.packageVerifyValue,
          "remark": item.remark.length > 20 ? item.remark.substring(0, 20) + "..." : item.remark,
          "createTime": item.createTime,
          "creator": item.creator,
          "status": item.status
        };
        data.push(option);
      });

      return (0, _jsx3.default)('div', {
        className: 'version-table'
      }, void 0, (0, _jsx3.default)(_modal2.default, {
        title: '\u5347\u7EA7\u5305\u5BF9\u5916\u4FE1\u606F\u8BE6\u60C5',
        visible: this.state.visibleShow,
        onCancel: this.handleCancelDetail,
        footer: false
      }, void 0, (0, _jsx3.default)('div', {
        className: 'detail-data'
      }, void 0, (0, _jsx3.default)('div', {
        className: 'data-one'
      }, void 0, '\u5916\u90E8\u7248\u672C\u53F7\uFF1A', codeVal), (0, _jsx3.default)('div', {
        className: 'data-one'
      }, void 0, '\u5916\u90E8\u7248\u672C\u7B80\u4ECB\uFF1A', infoVal), (0, _jsx3.default)('div', {
        className: 'data-one'
      }, void 0, '\u5916\u90E8\u7248\u672C\u66F4\u65B0\u8BF4\u660E\uFF1A', (0, _jsx3.default)('div', {
        style: { paddingLeft: 20 },
        dangerouslySetInnerHTML: explainVal
      }, void 0)), (0, _jsx3.default)('div', {
        className: 'data-one'
      }, void 0, '\u6B63\u5F0F\u53D1\u5E03\u65F6\u95F4\uFF1A', timeVal), (0, _jsx3.default)('div', {
        className: 'data-one'
      }, void 0, '\u7248\u672C\u8BE6\u60C5\uFF1A', ruleData))), (0, _jsx3.default)(_modal2.default, {
        title: '\u7F16\u8F91',
        visible: this.state.editShow,
        onCancel: this.handleCancelEdit,
        footer: false,
        width: '50%'
      }, void 0, visible ? (0, _jsx3.default)(_alert2.default, {
        message: '\u4FE1\u606F\u76F4\u63A5\u5448\u73B0\u5728\u7528\u6237App\u7AEF\uFF0C\u8BF7\u8BA4\u771F\u586B\u5199\u3002',
        type: 'info',
        style: { marginBottom: 20, marginLeft: 70, width: '80%' },
        closable: true,
        afterClose: this.handleClose
      }) : null, (0, _jsx3.default)('div', {
        className: 'info-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
      }, void 0, (0, _jsx3.default)('span', {
        style: { color: 'red' }
      }, void 0, '*'), '\u5916\u90E8\u7248\u672C\u53F7(app\u5C55\u793A)\uFF1A'), (0, _jsx3.default)('div', {
        style: { width: '50%' }
      }, void 0, (0, _jsx3.default)(_input2.default, {
        placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u53F7',
        value: codeVal,
        onChange: this.getCode
      }))), (0, _jsx3.default)('div', {
        className: 'info-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
      }, void 0, (0, _jsx3.default)('span', {
        style: { color: 'red' }
      }, void 0, '*'), '\u5916\u90E8\u7248\u672C\u7B80\u4ECB(app\u5C55\u793A)\uFF1A'), (0, _jsx3.default)('div', {
        style: { width: '50%' }
      }, void 0, (0, _jsx3.default)(_input2.default, {
        placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u7B80\u4ECB',
        value: infoVal,
        onChange: this.getInfo
      }))), (0, _jsx3.default)('div', {
        className: 'info-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
      }, void 0, (0, _jsx3.default)('span', {
        style: { color: 'red' }
      }, void 0, '*'), '\u5916\u90E8\u7248\u672C\u66F4\u65B0\u8BF4\u660E(app\u5C55\u793A)\uFF1A'), (0, _jsx3.default)('div', {
        style: { width: '50%' }
      }, void 0, (0, _jsx3.default)(TextArea, {
        placeholder: '\u8BF7\u8F93\u5165\u5916\u90E8\u7248\u672C\u66F4\u65B0\u8BF4\u660E',
        value: explainVal,
        onChange: this.getExplain
      }))), (0, _jsx3.default)('div', {
        className: 'info-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
      }, void 0, (0, _jsx3.default)('span', {
        style: { color: 'red' }
      }, void 0, '*'), '\u6B63\u5F0F\u53D1\u5E03\u65F6\u95F4\uFF1A'), (0, _jsx3.default)('div', {
        style: { width: '50%' }
      }, void 0, (0, _jsx3.default)(_datePicker2.default, {
        placeholder: '\u8BF7\u9009\u62E9\u6B63\u5F0F\u53D1\u5E03\u65F6\u95F4\uFF01',
        value: timeVal ? (0, _moment2.default)(timeVal, 'YYYY/MM/DD') : '',
        onChange: this.getTime
      }))), (0, _jsx3.default)('div', {
        className: 'info-data'
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '25%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }
      }, void 0, (0, _jsx3.default)('span', {
        style: { color: 'red' }
      }, void 0, '*'), '\u7248\u672C\u8BE6\u60C5\uFF1A'), (0, _jsx3.default)('div', {
        style: { width: '50%' }
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'dashed',
        onClick: this.clickChange.bind(this),
        style: { width: "100%" }
      }, void 0, _ref5, ' \u6DFB\u52A0'))), ruleVal.map(function (item, index) {
        return (0, _jsx3.default)(_row2.default, {
          style: { marginBottom: 20, paddingLeft: '20%', display: 'flex', justifyContent: 'center', flexWrap: 'wrap' },
          className: 'update-list'
        }, index, (0, _jsx3.default)(_col2.default, {
          span: 7
        }, void 0, _ref6, (0, _jsx3.default)(_select2.default, {
          defaultValue: item.componentType,
          onChange: _this4.handleChangeType.bind(_this4, index),
          style: { width: 80 }
        }, void 0, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14)), (0, _jsx3.default)(_col2.default, {
          span: 4
        }, void 0, item.componentType !== 7 ? null : (0, _jsx3.default)(_input2.default, {
          defaultValue: item.operator,
          onChange: _this4.handleChangeStatus.bind(_this4, index),
          placeholder: '\u56FA\u4EF6\u7C7B\u578B',
          style: { width: 80 }
        })), (0, _jsx3.default)(_col2.default, {
          span: 6
        }, void 0, _ref15, (0, _jsx3.default)(_input2.default, {
          defaultValue: item.partFirmwareVersion,
          onChange: _this4.handleChangeVal.bind(_this4, index),
          style: { width: 80 }
        })), (0, _jsx3.default)(_col2.default, {
          style: { lineHeight: '28px', color: '#3296FA' },
          span: 2
        }, void 0, (0, _jsx3.default)('span', {
          onClick: _this4.sc.bind(_this4, index),
          style: { cursor: 'pointer' }
        }, void 0, '\u5220\u9664')));
      }), (0, _jsx3.default)('div', {
        style: { width: '100%', display: 'flex', justifyContent: 'center' }
      }, void 0, (0, _jsx3.default)('div', {
        style: { width: '65%' }
      }, void 0, (0, _jsx3.default)('p', {
        style: { fontSize: 14, color: '#bbb' }
      }, void 0, '\u8BF4\u660E'), (0, _jsx3.default)('p', {
        style: { fontSize: 12, color: '#bbb' }
      }, void 0, '\u5347\u7EA7\u5305\u8BE6\u7EC6\u4FE1\u606F\u7528\u4E8E\u76F4\u63A5\u5448\u73B0\u7ED9\u7528\u6237APP\u7AEF\uFF0C\u4FE1\u606F\u53EF\u4E0D\u586B\u5199\u3002\u5982\u679C\u4E0D\u586B\u5199\uFF0C\u5219\u8BE5\u5305\u7684\u5347\u7EA7\u8BB0\u5F55\u4E0D\u4F1A\u663E\u793A\u5728\u5347\u7EA7\u8BB0\u5F55\u5217\u8868\u4E2D\uFF0C\u540C\u65F6\u4E0D\u4F1A\u628A\u5347\u7EA7\u72B6\u6001\u63A8\u9001\u7ED9\u7528\u6237\u3002'))), (0, _jsx3.default)('div', {
        style: { width: '100%', display: 'flex', justifyContent: 'center' }
      }, void 0, (0, _jsx3.default)(_button2.default, {
        type: 'primary',
        onClick: this.skipSubmit,
        style: { marginRight: 20 }
      }, void 0, '\u63D0\u4EA4'), (0, _jsx3.default)(_button2.default, {
        onClick: this.handleCancelEdit
      }, void 0, '\u53D6\u6D88'))), (0, _jsx3.default)('div', {
        className: 'version-index-title'
      }, void 0, (0, _jsx3.default)('div', {}, void 0, (0, _jsx3.default)('div', {
        className: 'version-index-pro'
      }, void 0, name), (0, _jsx3.default)('div', {
        className: 'version-index-total'
      }, void 0, '\u5347\u7EA7\u5305\u603B\u6570\uFF1A', total, '\u4E2A')), (0, _jsx3.default)('div', {
        className: 'version-index-form'
      }, void 0, (0, _jsx3.default)(_search2.default, {
        onSubmit: this.handleSubmit.bind(this),
        increate: increate,
        search: this.search,
        uid: uid
      }))), (0, _jsx3.default)(_table2.default, {
        pagination: pagination,
        columns: columns,
        dataSource: data,
        onChange: this.onChange
      }), (0, _jsx3.default)(_modal2.default, {
        title: '\u4FEE\u6539\u72B6\u6001',
        visible: this.state.statusvisible,
        onOk: this.handleOk.bind(this),
        onCancel: this.handleCancel.bind(this)
      }, void 0, '\u72B6\u6001\uFF1A', (0, _jsx3.default)(_select2.default, {
        defaultValue: '',
        style: { width: 120 },
        onChange: this.handleStatusChange.bind(this)
      }, void 0, vList.map(function (item, index) {
        return (0, _jsx3.default)(Option, {
          value: item.key
        }, index, item.value);
      }))));
    }
  }]);
  return Main;
}(_react.Component);

exports.default = (0, _template2.default)({
  id: 'device-table', // 应用关联使用的redux
  component: Main, // 接收数据的组件入口
  url: ''
});

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/version/table/index.jsx
// module id = 1520
// module chunks = 0